import React from 'react'
import withSWR from './with-swr'
import {getActivity, ACTIVITY_SWR_KEY} from '../backend'

const withActivityData = (Component, loaderText = 'Loading activity...') => {
  return withSWR((props) => {
    return (<Component {...props}/>)
  }, {
    key: ACTIVITY_SWR_KEY,
    fetcher: getActivity,
    mutateFuncKey: 'mutateActivity',
    onLoadingProps: {activityLoading: true},
    onLoadedProps: {activityLoaded: true},
    loaderText
  })
}

export {withActivityData}

export default withActivityData